module.exports = __webpack_public_path__ + "assets/img/6bef6cf9d4f77779e9c59dac928a6bb9.png";